import Agreements from './agreements';
export default Agreements;
